/*
  Pokitrio-Redesign: Plus der Produktkarte (snippets/pkt-product-card.liquid). Ohne Formular je Karte.

  * [data-pkt-add="<variant-id>"]: legt direkt in den Warenkorb. Ablauf wie Impacts <form is="product-form">
    (theme.js, ProductForm._onSubmit): cart:prepare-bundled-sections -> POST cart/add.js (mit sections,
    sections_url) -> cart.js -> variant:add (bubbles, vom Plus) + cart:change auf documentElement. Damit
    aktualisieren sich Zaehler und Warenkorb-Drawer, und der Drawer oeffnet sich. Fehler: cart:error + cart:refresh.
  * [data-pkt-auswahl="<handle>"]: laedt /products/<handle>.js und zeigt einen Dialog (natives <dialog>: Fokusfalle,
    Escape; auf dem Handy als Sheet) mit Variante, Preis und "Ausverkauft" (deaktiviert). Ein Tipp legt in den
    Warenkorb; der Dialog schliesst vor den Impact-Ereignissen, damit der Drawer nicht hinter ihm aufgeht.
  * Meldungen (Fehler) gehen in eine aria-live-Region, die zugleich sichtbar als Hinweis erscheint. Ist der Dialog
    offen (showModal macht den Rest der Seite inert), steht die Meldung im Dialog selbst.
  * window.pktWarenkorb = { hinzufuegen(positionen, ausloeser), preis(cent) }: dieselbe Event-Folge fuer mehrere
    Positionen in einem Aufruf (Plan 4 Task 4, „Wird häufig zusammen gekauft“, assets/pkt-fbt.js). hinzufuegen liefert
    { ok } bzw. { ok: false, fehler, shop } (shop: Text kommt von Shopify, z. B. Mengenlimit) oder { belegt: true },
    solange der Ausloeser noch arbeitet (aria-busy). Die Meldung zeigt der Aufrufer selbst.
  * Plus im Warenkorb-Drawer (Cross-Selling, snippets/pkt-cart-xsell.liquid, Plan 4 Task 5 Politur): Impact ersetzt
    den Drawer-Inhalt nach cart:change per innerHTML, der fokussierte Button verschwindet. Liegt der Ausloeser im
    Drawer, setzt drawerFokus() danach (setTimeout nach Impacts setTimeout 0, dann requestAnimationFrame) den Fokus
    auf den Kasten-Titel bzw. ersatzweise auf den Kopf (tabindex="-1", ohne Fokusring) und sagt die Erfolgsmeldung
    ueber Impacts announceStatus an (Fallback: #status-announcement). Karten-Plus und FBT ausserhalb des Drawers
    bleiben unveraendert.
  * Fehler beim Plus im Drawer: Die Meldung steht im Drawer (meldeImDrawer, role="alert" unter dem Kopf), nachdem
    Impact ihn per cart:refresh neu aufgebaut hat; der Fokus geht auf .pkt-wk__titel. Ausserhalb des Drawers bleibt
    es beim Hinweis unten (melde).
  Texte: window.pktTexte (layout/theme.liquid, Locale pkt.* bzw. Impact-Strings).
*/
(() => {
  if (window.pktKarte) return;
  window.pktKarte = true;

  const T = Object.assign({
    variante_waehlen: 'Variante wählen',
    ausverkauft: 'Ausverkauft',
    preis_folgt: 'Preis folgt',
    fehler: 'Konnte nicht in den Warenkorb gelegt werden.',
    schliessen: 'Schließen',
    hinzugefuegt: 'Zum Warenkorb hinzugefügt!',
  }, window.pktTexte || {});
  const wurzel = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const waehrung = () => (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  // Intl setzt ein geschuetztes Leerzeichen vor das Euro-Zeichen, das Shrikhand zu breit zeichnet: normales Leerzeichen,
  // der Preis bricht per CSS (white-space: nowrap) trotzdem nicht um.
  const preis = (cent) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: waehrung() }).format(cent / 100).replace(/\u00a0/g, ' ');

  /* ---------- Meldung (aria-live, sichtbar) ---------- */
  let meldung = null;
  let dialog = null;
  let meldungTimer = null;
  function melde(text) {
    if (dialog && dialog.open) {
      const ort = dialog.querySelector('.pkt-wahl__meldung');
      ort.textContent = '';
      window.requestAnimationFrame(() => { ort.textContent = text; ort.hidden = false; });
      return;
    }
    if (!meldung) {
      meldung = document.createElement('div');
      meldung.className = 'pkt-meldung';
      meldung.setAttribute('role', 'status');
      meldung.setAttribute('aria-live', 'polite');
      document.body.append(meldung);
    }
    meldung.textContent = '';
    window.requestAnimationFrame(() => {
      meldung.textContent = text;
      meldung.classList.add('is-sichtbar');
    });
    window.clearTimeout(meldungTimer);
    meldungTimer = window.setTimeout(() => meldung.classList.remove('is-sichtbar'), 6000);
  }

  /* ---------- Drawer: Fokus und Ansage nach dem Neu-Rendern ---------- */
  function ansagen(text) {
    import('theme').then((m) => m.announceStatus(text)).catch(() => {
      const ort = document.getElementById('status-announcement');
      if (!ort) return;
      ort.textContent = '';
      window.setTimeout(() => { ort.textContent = text; }, 100);
    });
  }

  function drawerFokus() {
    window.setTimeout(() => window.requestAnimationFrame(() => {
      const drawer = document.querySelector('cart-drawer');
      const ziel = drawer && (drawer.querySelector('.pkt-xsell__titel') || drawer.querySelector('.pkt-wk__titel'));
      if (ziel) ziel.focus({ preventScroll: false });
      ansagen(T.hinzugefuegt);
    }), 0);
  }

  /* Fehler beim Plus im Drawer: Impact baut den Drawer nach cart:refresh komplett neu auf (replaceChildren nach einem
     fetch). Erst danach steht die Meldung als role="alert" unter dem Kopf, und der Fokus geht auf den Drawer-Titel.
     Kommt kein Neuaufbau (Netz weg), zeigt der Notfall-Timer die Meldung im bestehenden Drawer. */
  function meldeImDrawer(text) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) { melde(text); return; }
    let fertig = false;
    let notfall = null;
    const beobachter = new MutationObserver(() => zeige());
    function zeige() {
      if (fertig) return;
      fertig = true;
      beobachter.disconnect();
      window.clearTimeout(notfall);
      window.requestAnimationFrame(() => {
        drawer.querySelectorAll('.pkt-wk__meldung').forEach((alt) => alt.remove());
        const ort = document.createElement('p');
        ort.className = 'pkt-wk__meldung';
        ort.setAttribute('role', 'alert');
        ort.textContent = text;
        const kopf = drawer.querySelector('.pkt-wk__kopf');
        const innen = drawer.querySelector('.cart-drawer__inner');
        if (kopf) kopf.after(ort);
        else if (innen) innen.prepend(ort);
        else drawer.prepend(ort);
        const titel = drawer.querySelector('.pkt-wk__titel');
        if (titel) titel.focus({ preventScroll: false });
      });
    }
    beobachter.observe(drawer, { childList: true });
    notfall = window.setTimeout(zeige, 4000);
  }

  /* ---------- In den Warenkorb ---------- */
  async function inDenWarenkorb(positionen, ausloeser, vorDenEreignissen) {
    if (ausloeser.getAttribute('aria-busy') === 'true') return { ok: false, belegt: true };
    ausloeser.setAttribute('aria-busy', 'true');
    const sections = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
    try {
      const antwort = await fetch(`${wurzel()}cart/add.js`, {
        method: 'POST',
        body: JSON.stringify({ items: positionen.map((p) => ({ id: Number(p.id), quantity: p.quantity || 1 })),
          sections: sections.join(','), sections_url: `${wurzel()}variants/${positionen[0].id}` }),
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      });
      const json = await antwort.json();
      if (!antwort.ok) {
        const abgelehnt = new Error(json.description || json.message || T.fehler);
        abgelehnt.pktShop = !!(json.description || json.message);
        throw abgelehnt;
      }
      const einst = (window.themeVariables && window.themeVariables.settings) || {};
      if (einst.cartType === 'page' || einst.pageType === 'cart') {
        window.location.href = `${wurzel()}cart`;
        return { ok: true };
      }
      const warenkorb = await (await fetch(`${wurzel()}cart.js`)).json();
      warenkorb.sections = json.sections;
      const imDrawer = !!ausloeser.closest('cart-drawer');
      if (vorDenEreignissen) vorDenEreignissen();
      ausloeser.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        detail: { items: Object.prototype.hasOwnProperty.call(json, 'items') ? json.items : [json], cart: warenkorb },
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', cart: warenkorb },
      }));
      if (imDrawer) drawerFokus();
      return { ok: true };
    } catch (fehler) {
      // Netzwerk- oder Parse-Fehler: eigener Text statt Browsermeldung („Failed to fetch“)
      const shop = !!(fehler && fehler.pktShop);
      const text = shop ? fehler.message : T.fehler;
      ausloeser.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: text } }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return { ok: false, fehler: text, shop };
    } finally {
      ausloeser.removeAttribute('aria-busy');
    }
  }

  async function lege(variante, ausloeser, vorDenEreignissen) {
    // vor dem Aufruf merken: nach cart:refresh ist der Ausloeser nicht mehr im Drawer (neu aufgebaut)
    const drawerAusloeser = !!ausloeser.closest('cart-drawer');
    const ergebnis = await inDenWarenkorb([{ id: variante, quantity: 1 }], ausloeser, vorDenEreignissen);
    if (!ergebnis.ok && !ergebnis.belegt) {
      if (drawerAusloeser) meldeImDrawer(ergebnis.fehler);
      else melde(ergebnis.fehler);
    }
    return ergebnis.ok;
  }

  window.pktWarenkorb = { hinzufuegen: inDenWarenkorb, preis };

  /* ---------- Variantenauswahl ---------- */
  function baueDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'pkt-wahl';
    dialog.setAttribute('aria-labelledby', 'pkt-wahl-titel pkt-wahl-name');
    const kopf = document.createElement('div');
    kopf.className = 'pkt-wahl__kopf';
    const titel = document.createElement('div');
    const kicker = document.createElement('p');
    kicker.className = 'pkt-wahl__kicker';
    kicker.id = 'pkt-wahl-titel';
    kicker.textContent = T.variante_waehlen;
    const name = document.createElement('p');
    name.className = 'pkt-wahl__name';
    name.id = 'pkt-wahl-name';
    titel.append(kicker, name);
    const zu = document.createElement('button');
    zu.type = 'button';
    zu.className = 'pkt-wahl__zu';
    zu.setAttribute('aria-label', T.schliessen);
    zu.innerHTML = '<svg class="pkt-ic" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    zu.addEventListener('click', () => dialog.close());
    kopf.append(titel, zu);
    const liste = document.createElement('ul');
    liste.className = 'pkt-wahl__liste';
    liste.setAttribute('role', 'list');
    // Fehler bei offenem Dialog: eigene Live-Region im Dialog (sichtbar, auch im Handy-Sheet)
    const ort = document.createElement('p');
    ort.className = 'pkt-wahl__meldung';
    ort.setAttribute('role', 'status');
    ort.setAttribute('aria-live', 'polite');
    ort.hidden = true;
    dialog.append(kopf, ort, liste);
    // Klick auf den abgedunkelten Rand (ausserhalb des Dialog-Rechtecks) schliesst; Innenabstand zaehlt zum Dialog
    dialog.addEventListener('click', (e) => {
      if (e.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      const drin = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!drin) dialog.close();
    });
    document.body.append(dialog);
    return dialog;
  }

  async function waehle(plus) {
    if (plus.getAttribute('aria-busy') === 'true') return;
    plus.setAttribute('aria-busy', 'true');
    let produkt;
    try {
      const antwort = await fetch(`${wurzel()}products/${encodeURIComponent(plus.dataset.pktAuswahl)}.js`);
      if (!antwort.ok) throw new Error(T.fehler);
      produkt = await antwort.json();
    } catch (fehler) {
      melde(T.fehler);
      return;
    } finally {
      plus.removeAttribute('aria-busy');
    }
    const d = baueDialog();
    d.querySelector('.pkt-wahl__name').textContent = plus.dataset.pktName || produkt.title;
    const liste = d.querySelector('.pkt-wahl__liste');
    liste.replaceChildren();
    const ort = d.querySelector('.pkt-wahl__meldung');
    ort.hidden = true;
    ort.textContent = '';
    let fertig = false;
    produkt.variants.forEach((v) => {
      const li = document.createElement('li');
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'pkt-wahl__opt';
      b.disabled = !(v.available && v.price > 0);
      const n = document.createElement('span');
      n.className = 'pkt-wahl__var';
      n.textContent = v.public_title || v.title;
      const p = document.createElement('span');
      p.className = 'pkt-wahl__preis';
      p.textContent = v.price > 0 ? preis(v.price) : T.preis_folgt;
      b.append(n, p);
      b.setAttribute('aria-label', [n.textContent, p.textContent].concat(v.available ? [] : [T.ausverkauft]).join(', '));
      if (!v.available) {
        const aus = document.createElement('span');
        aus.className = 'pkt-wahl__aus';
        aus.textContent = T.ausverkauft;
        b.append(aus);
      }
      b.addEventListener('click', async () => {
        b.setAttribute('aria-busy', 'true');
        await lege(String(v.id), plus, () => { fertig = true; d.close(); });
        b.removeAttribute('aria-busy');
      });
      li.append(b);
      liste.append(li);
    });
    // Abbruch: Fokus zurueck aufs Plus. Nach dem Hinzufuegen uebernimmt der Warenkorb-Drawer den Fokus.
    d.addEventListener('close', () => { if (!fertig && document.contains(plus)) plus.focus(); }, { once: true });
    d.showModal();
    const erste = liste.querySelector('button:not([disabled])') || d.querySelector('.pkt-wahl__zu');
    erste.focus();
  }

  document.addEventListener('click', (e) => {
    const direkt = e.target.closest('[data-pkt-add]');
    if (direkt) {
      e.preventDefault();
      lege(direkt.dataset.pktAdd, direkt);
      return;
    }
    const auswahl = e.target.closest('[data-pkt-auswahl]');
    if (auswahl) {
      e.preventDefault();
      waehle(auswahl);
    }
  });
})();
